import React from 'react';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CustomButton from '../../../components/buttons/CustomButton';
import BudgetTemplate from '../../../components/documents-templates/BudgetTemplate';
import { formatPhone } from '../../../utils/phoneUtils';
import { DialogHeader, dialogPaperProps } from './BudgetPickerDialog';
import styles from './BudgetDialogs.module.css';

/**
 * Prévia do orçamento. O div de templateRef é exatamente o que vira PDF:
 * nada de estilo nele, só no fundo cinza ao redor.
 */
function BudgetPreviewDialog({ open, onClose, onSave, templateRef, companyData, budgetData, date, professionalName }) {
  const documentCompany = companyData ? { ...companyData, Phone: formatPhone(companyData.Phone || '') } : companyData;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={dialogPaperProps}>
      <DialogHeader
        icon={<VisibilityOutlinedIcon />}
        title="Prévia do orçamento"
        subtitle="É assim que o PDF vai sair."
      />
      <DialogContent className={styles.previewContent}>
        <div ref={templateRef}>
          <BudgetTemplate
            companyData={documentCompany}
            budgetData={budgetData}
            date={date}
            professionalName={professionalName}
          />
        </div>
      </DialogContent>
      <DialogActions className={styles.actions}>
        <CustomButton label="Fechar" style="primary" variant="outlined" onClick={onClose} />
        <CustomButton
          label="Salvar PDF"
          style="primary"
          variant="contained"
          icon={<PictureAsPdfOutlinedIcon />}
          onClick={onSave}
        />
      </DialogActions>
    </Dialog>
  );
}

export default BudgetPreviewDialog;
